import { Component, OnInit } from "@angular/core";

import { BaseControlComponent } from "../../../../../../../../form-controls/components/base-control/base-control.component";
import { ensureWellComponentConfig, WellConfigType, WellConfigurationData, GisContextLocationType } from "../../../../../../../../form-controls/components/new-casing-plan/models/casing-plan.model";
import { ContextInteractionService } from "../../../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-casing-plan-grid-data-config",
    templateUrl: "./casing-plan-grid-data-config.component.html",
    styleUrls: ["./casing-plan-grid-data-config.component.scss"],
    standalone: false
})
export class CasingPlanGridDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "CasingPlanGridDataConfigComponent";

    get multipleEntryOptions(): WellConfigurationData[] {
        return this.componentData.config.wellDataPoints.filter(p => p.locationType === GisContextLocationType.MultipleRead);
    }

    get singleEntryOptions(): WellConfigurationData[] {
        return this.componentData.config.wellDataPoints.filter(p => p.locationType === GisContextLocationType.ReadOnly);
    }


    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        this.initializeConfig();
    }

    addEntry(option: WellConfigurationData) {
        option.multipleLocations.push(" ");
        return false;
    }

    generateMultiId(name: string, index: number): string {
        return `${name}_${index}`;
    }

    initializeConfig(): void {
        this.componentData.config.wellDataPoints = ensureWellComponentConfig(WellConfigType.NewCasingPlan, this.componentData.config.wellDataPoints);
        if (this.componentData.config.useNAD == null) {
            this.componentData.config.useNAD = true;
        }
        if (this.componentData.config.enforcePositionRequirement == null) {
            this.componentData.config.enforcePositionRequirement = false;
        }
    }

}
